import { render, staticRenderFns } from "./down.vue?vue&type=template&id=38dd17a3"
import script from "./down.vue?vue&type=script&lang=js"
export * from "./down.vue?vue&type=script&lang=js"
import style0 from "./down.vue?vue&type=style&index=0&id=38dd17a3&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/jenkins_workspace/workspace/vuejs-tb-train-admin-web-sim/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38dd17a3')) {
      api.createRecord('38dd17a3', component.options)
    } else {
      api.reload('38dd17a3', component.options)
    }
    module.hot.accept("./down.vue?vue&type=template&id=38dd17a3", function () {
      api.rerender('38dd17a3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/vue-browser-down/down.vue"
export default component.exports